import React from 'react'
import Swiper from 'react-id-swiper/lib/ReactIdSwiper'
import { useSelector } from 'react-redux'
import { BubblingTooltip, Button, Image, InjectHtml, SwiperArrows } from '@/components/ui'
import { useSwiper } from '@/components/ui/SwiperArrows/useSwiper'
import { isAuthenticated as isUserAuthenticated, isUserAgrarian } from '@/logic/auth/reducer'
import type { RootState } from '@/redux/interfaces'
import { useWebpExtension } from '@/utils/hooks/image'
import type { ICarMarksOfferProps } from './interfaces'
import { messages } from './messages'
import './styles.scss'

const mapState = (state: RootState) => ({
  isAgrarian: isUserAgrarian()(state),
  isAuthenticated: isUserAuthenticated()(state),
})

const CarMarksOffer: React.FC<ICarMarksOfferProps> = props => {
  const { marks, onActionClick, blockId, buttonTooltipMessageId } = props
  const imageExtension = useWebpExtension()
  const { swiperRef, slideNext, slidePrevious } = useSwiper()
  const { isAgrarian, isAuthenticated } = useSelector(mapState)

  const shouldDisableButton = isAuthenticated && !isAgrarian

  const marksImages = marks?.map(markName => (
    <span key={markName} className="landing-header-cars-item col-2 col-12-sm">
      <Image src={`machineMarks/${markName}.${imageExtension}`} isInStatic />
    </span>
  ))

  const actionButton = (
    <Button modifiers={['green']} onClick={onActionClick} isDisabled={Boolean(buttonTooltipMessageId) && shouldDisableButton}>
      {messages.offerButton}
    </Button>
  )

  return (
    <section className="landing-header-cars">
      <div className="page-wrapper landing-header-content">
        <h2 className="space-holder24 space-holder16-sm space-holder-top16 space-holder-top0-sm landing-header__title">{messages.title}</h2>
        <InjectHtml html={messages.description} className="space-holder40 space-holder32-sm landing-header__text" TagName="p" />
        <div className="row row-align_center row-justify_center-sm space-holder80 space-holder32-sm" id={blockId}>
          {buttonTooltipMessageId && shouldDisableButton ? (
            <BubblingTooltip messageId={buttonTooltipMessageId}>
              <span>{actionButton}</span>
            </BubblingTooltip>
          ) : (
            actionButton
          )}
        </div>
        <div className="wide-mobile-block hidden-from-sm space-holder32-sm">
          <Image src="financingOffer/carMarksOfferBannerMobile.png" isInStatic />
        </div>
        <div>
          <h5>{messages.popularMarks.label}</h5>
          <Swiper containerClass="overflow_visible hidden-sm" ref={swiperRef} slidesPerView="auto">
            {marksImages}
          </Swiper>
          <div className="landing-car-marks hidden-from-sm space-holder-top32-sm">{marksImages}</div>
          <SwiperArrows
            onClickLeftArrow={slidePrevious}
            onClickRightArrow={slideNext}
            modifier="swiper-gray"
            className="landing-header-cars__buttons row-justify_end"
            buttonClassName="landing-header-cars__button"
          />
        </div>
      </div>
    </section>
  )
}

export default CarMarksOffer
